import React from 'react';
import styled, { css } from 'styled-components';
import {
  headingStyles,
  minBreakpointQuery,
  sectionPaddings,
  standardColours,
} from '../styles';
import { Container, HtmlContent } from './ui';
import ProductCategoryCard from './ProductCategoryCard';
import ListingCtaCard from './ListingCtaCard';

const StyledProductCategoryListing = styled.section`
  ${sectionPaddings('25px', '40px')};
  background-color: ${standardColours.lightestGrey};
`;

const StyledHeader = styled.header`
  margin-bottom: 20px;
  text-align: center;

  ${minBreakpointQuery.small`
    margin-bottom: 25px;
  `}

  ${minBreakpointQuery.large`
    margin-bottom: 30px;
  `}
`;

const StyledHeading = styled.h1`
  ${headingStyles()};
`;

const StyledText = styled(HtmlContent)`
  margin-top: 10px;

  ${minBreakpointQuery.small`
    margin-top: 12px;
  `}

  ${minBreakpointQuery.large`
    margin-top: 14px;
  `}

  p {
    margin-bottom: 10px;

    ${minBreakpointQuery.small`
      margin-bottom: 12px;
    `}

    ${minBreakpointQuery.large`
      margin-bottom: 14px;
    `}
  }
`;

const StyledItems = styled.div`
  display: grid;
  gap: 20px;

  ${minBreakpointQuery.tsmall`
    grid-template-columns: repeat(2, 1fr);
  `}

  ${minBreakpointQuery.small`
    row-gap: 25px;
  `}

  ${minBreakpointQuery.smedium`
    grid-template-columns: repeat(3, 1fr);
  `}

  ${minBreakpointQuery.medium`
    row-gap: 30px;
  `}

  ${minBreakpointQuery.xlarge`
    grid-template-columns: repeat(4, 1fr);
  `}
`;

const StyledItem = styled(ProductCategoryCard)`
  ${({ isFeatured }) => {
    if (isFeatured) {
      return css`
        ${minBreakpointQuery.xlarge`
          grid-column: span 2;
        `}
      `;
    }
  }}
`;

const ProductCategoryListing = ({ heading, text, items }) =>
  items &&
  items.length > 0 && (
    <StyledProductCategoryListing id="product-category-listing">
      <StyledHeader>
        <Container narrow={true}>
          <StyledHeading>{heading}</StyledHeading>
          <StyledText content={text} />
        </Container>
      </StyledHeader>
      <Container wide={true}>
        <StyledItems>
          {items.map((item, i) =>
            item.internal &&
            item.internal.type === 'DatoCmsListingCallToAction' ? (
              <ListingCtaCard key={i} {...item} />
            ) : (
              <StyledItem key={i} {...item} isFirstInListing={i === 0} />
            ),
          )}
        </StyledItems>
      </Container>
    </StyledProductCategoryListing>
  );

export default ProductCategoryListing;
